import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { buttonVariants } from '@/components/app/button';
import { SectionWrapper } from '@/features/homepage/components/shared';
import { cn } from '@/lib/utils';

function Overview() {
	const { t } = useTranslation();

	return (
		<SectionWrapper heading={t('home.overview.heading')}>
			<div className="flex flex-col gap-4 px-6">
				<OverviewStep
					index={t('common.number', { value: 1 })}
					title={t('home.overview.sections.chooseYourProgram.title')}
					content={t('home.overview.sections.chooseYourProgram.content')}
					buttonText={t('home.overview.sections.chooseYourProgram.button')}
				/>
				<OverviewStep
					index={t('common.number', { value: 2 })}
					title={t('home.overview.sections.playVideo.title')}
					content={t('home.overview.sections.playVideo.content')}
				/>
				<OverviewStep
					index={t('common.number', { value: 3 })}
					title={t('home.overview.sections.recordYourWorkout.title')}
					content={t('home.overview.sections.recordYourWorkout.content')}
				/>
				<OverviewStep
					index={t('common.number', { value: 4 })}
					title={t('home.overview.sections.trainerFeedback.title')}
					content={t('home.overview.sections.trainerFeedback.content')}
				/>
			</div>
		</SectionWrapper>
	);
}

function OverviewStep({
	index,
	title,
	content,
	buttonText,
}: {
	index: string;
	title: string;
	content: string;
	buttonText?: string;
}) {
	return (
		<div className="group/overview-section relative">
			<span className="-start-5 absolute top-8 h-[calc(100%+1rem)] w-[1px] border-ash-500 border-l border-dashed group-last/overview-section:hidden" />
			<span className="relative my-4 grid size-8 place-items-center rounded-full border border-ash-500 bg-white [box-shadow:0px_4px_0px_var(--color-ash-300)]">
				<span className="-start-5 absolute w-5 border-ash-500 border-b border-dashed" />
				<span className="adjust-vertical-position">{index}</span>
			</span>
			<h3 className="my-2 ps-5">{title}</h3>
			<p className="ps-5 text-ash-700">{content}</p>
			{buttonText && (
				<Link
					to="/programs"
					className={cn('float-end mt-4', buttonVariants({ variant: 'secondary' }))}
				>
					{buttonText}
				</Link>
			)}
		</div>
	);
}

export { Overview };
